import {
    getName,
    getProfilePictureTimestamp,
    getProfilePictureUrl,
    TSalesManager,
} from '@internal/services/TSalesManager';
import { ImageTransformations } from '@internal/utils/media/Media';
import { FC, useMemo } from 'react';

type Props =
    | {
          variant: 'avatar';
          salesManager: TSalesManager;
          size: number;
          className?: string;
      }
    | {
          variant: 'indoors' | 'outdoors';
          salesManager: TSalesManager;
          width: number;
          height: number;
          className?: string;
      };

export const ProfilePicture: FC<Props> = props => {
    const media = useMemo(() => {
        const transformations: ImageTransformations = {
            focus: 'face',
            zoom: 0.3,
        };

        if (props.variant === 'avatar') {
            transformations.width = props.size;
            transformations.height = props.size;
            transformations.radius = 'max';
        } else {
            transformations.width = props.width;
            transformations.height = props.height;
        }

        return {
            id: props.salesManager.id,
            variant: props.variant,
            zohoUserId: props.salesManager.zohoUserId,
            transformations,
            timestamp: getProfilePictureTimestamp(
                props.salesManager,
                props.variant,
            ),
        };
        // biome-ignore lint/correctness/useExhaustiveDependencies: unknown effect of fix
    }, [props]);

    if (!props.salesManager.zohoUserId) {
        return null;
    }

    return (
        <img
            className={props.className}
            loading="lazy"
            alt={getName(props.salesManager)}
            width={media.transformations.width}
            height={media.transformations.height}
            src={getProfilePictureUrl(media)}
        />
    );
};
